import { rem } from 'polished';
import { css } from 'styled-components';
import { media } from '@luigiclaudio/ga-baseline-ui/layout';
import { isNumber } from 'lodash';

const colorVariantHorizontalSpacingStyles = () => css`
    ${({ stepValue }) => {
        if (isNumber(stepValue)) {
            return css`
                margin-left: ${rem(3)};
                margin-right: ${rem(3)};

                ${media.xs`
                    margin-left: ${rem(4)};
                    margin-right: ${rem(4)};
                `}

                ${media.lg`
                margin-left: ${rem(8)};
                margin-right: ${rem(8)};
            `}
            `;
        }

        return css`
            margin-left: 0;
            margin-right: 0;
        `;
    }}
`;

// eslint-disable-next-line import/prefer-default-export
export { colorVariantHorizontalSpacingStyles };
